import Handlebars from 'handlebars/dist/cjs/handlebars';

Handlebars.registerHelper('truncate', (passedString, startstring, endstring) => {
  const theString = passedString.substring(startstring, endstring);

  if (passedString.length > endstring) {
    return new Handlebars.SafeString(`${theString}...`);
  } else {
    return new Handlebars.SafeString(`${theString}`);
  }
});
